export enum LocalizationId {
    Admin = "account-types.admin",
    Agent = "account-types.agent",
    CorporateLandlord = "account-types.corporate_landlord",
    PrivateLandlord = "account-types.private_landlord",
    Tenant = "account-types.tenant",
    Landlord = "account-types.landlord",
    None = "account-types.none",
}
